export default "__VITE_ASSET__3xq5nZkR__"